import tw from 'tailwind-styled-components';

const Bold = (c: any) => tw(c)`font-[500]`;

const Light = (c: any) => tw(c)`font-[400]`;

const Underline = (c: any) => tw(c)`underline`;

const Serif = {
  H1: tw.h1`font-serif text-[40px] leading-[50px] font-[400]` as any,
  H2: tw.h2`font-serif text-[32px] leading-[40px] font-[400]` as any,
  H3: tw.h3`font-serif text-[24px] leading-[30px] font-[400]` as any,
  H4: tw.h3`font-serif text-[18px] leading-[28px] font-[400]` as any,
};

const H1 =
  tw.h1`text-[20px] font-[400] leading-[28px] md:text-[32px] md:leading-[36px] md:font-[500]` as any;
const H2 = tw.h2`text-[24px] leading-[32px] font-[500]` as any;
const H3 = tw.h3`text-[20px] leading-[28px] font-[500]` as any;
const H4 = tw.h4`text-[18px] leading-[28px] font-[500]` as any;
H4.Bold = Bold(H4);

Serif.H1.Light = Light(Serif.H1);

const P = tw.p`text-[16px] leading-[24px] font-[400]` as any;
P.Bold = Bold(P);
P.Inline = tw.span`text-[16px] leading-[24px]`;
P.Inline.Bold = Bold(P.Inline);
P.Inline.Bold.Underline = Underline(Bold(P.Inline));

const Small = tw.span`text-[14px] leading-[20px] font-[400]` as any;
Small.Bold = Bold(Small);
Small.Bold.Underline = Underline(Bold(Small));

const SmallBlock = tw.p`text-[14px] leading-[20px] font-[400]` as any;
SmallBlock.Bold = Bold(SmallBlock);
Small.Block = SmallBlock;

const XSmall = tw.span`text-[12px] leading-[16px] font-[400]` as any;
XSmall.Bold = Bold(XSmall);

export default {
  H1,
  H2,
  H3,
  H4,
  Serif,
  P,
  Small,
  XSmall,
};
